const conf = {
  mapsApi: process.env.REACT_APP_MAPS_API_KEY,
  appUrl: process.env.REACT_APP_URL,
  isDev: process.env.REACT_APP_IS_DEV === 'true',
  islocal: process.env.REACT_APP_IS_LOCAL === 'true',
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  environment: process.env.NODE_ENV,
  photosUrl: process.env.REACT_APP_PHOTOS_URL,
  placesUrl: process.env.REACT_APP_PLACES_API_URL,
  apiUrl: process.env.REACT_APP_API_URL,
  newApiUrl: process.env.REACT_APP_NEW_API_URL,
  extApiKey: process.env.REACT_APP_EXT_API_KEY,
  basicApiKey: process.env.REACT_APP_BASIC_API_KEY,
};

export const {
  mapsApi,
  appUrl,
  isDev,
  googleClientId,
  environment,
  photosUrl,
  placesUrl,
  apiUrl,
  newApiUrl,
  extApiKey,
  basicApiKey,
} = conf;
